import { render, staticRenderFns } from "./FooterLandingPage.vue?vue&type=template&id=6c144836&scoped=true"
import script from "./FooterLandingPage.vue?vue&type=script&lang=js"
export * from "./FooterLandingPage.vue?vue&type=script&lang=js"
import style0 from "./FooterLandingPage.vue?vue&type=style&index=0&id=6c144836&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c144836",
  null
  
)

export default component.exports